import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function PhotographerLogin() {
  const { loginPhotographer } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await loginPhotographer(email, password);
      navigate('/photographer');
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: '80px auto', padding: 24 }}>
      <h2>Photographer Sign In</h2>
      {new URLSearchParams(window.location.search).get('expired') === '1' && (
        <div style={{
          background: '#fef3c7', border: '1px solid #f59e0b', color: '#92400e',
          padding: '10px 12px', borderRadius: 6, marginBottom: 12, fontSize: 14,
        }}>
          Your session expired, so your last action was not saved. Sign in again and redo it.
        </div>
      )}
      <p style={{ color: '#6b7280' }}>Manage your assigned dealerships' vehicle assets.</p>
      <form onSubmit={submit}>
        <input type="email" placeholder="Email" value={email}
          onChange={(e) => setEmail(e.target.value)} required style={inp} />
        <input type="password" placeholder="Password" value={password}
          onChange={(e) => setPassword(e.target.value)} required style={inp} />
        {error && <div style={{ color: '#dc2626', marginBottom: 12 }}>{error}</div>}
        <button type="submit" disabled={busy} style={btn}>
          {busy ? 'Signing in…' : 'Sign In'}
        </button>
      </form>
    </div>
  );
}

const inp = { width: '100%', padding: 10, marginBottom: 12, border: '1px solid #d1d5db', borderRadius: 6, boxSizing: 'border-box' };
const btn = { width: '100%', padding: 10, background: '#0078D4', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' };
